module.exports = __webpack_public_path__ + "img/hsh.b60e3820.png";